<template>
  <div class="action-layer">
    <effects-carousel-preloader-vue/>  
    <div :class="['action-layer__galleries']">
      <action-menu/>
      <background-gallery class="action-layer__gallery" v-show="applicationStore.activeActionTab === ActionMenuTabs.BACKGROUND"/>
      <text-gallery class="action-layer__gallery" v-show="applicationStore.activeActionTab === ActionMenuTabs.TEXT"/>
      <sticker-gallery class="action-layer__gallery" v-show="applicationStore.activeActionTab === ActionMenuTabs.STICKERS"/>
      <effects-gallery class="action-layer__gallery" v-show="applicationStore.activeActionTab === ActionMenuTabs.EFFECTS"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import EffectsCarouselPreloaderVue from '@/components/effect/EffectsCarouselPreloader.vue'
import ActionMenu from '@/components/action-menu/ActionMenu.vue'
import BackgroundGallery from '@/components/background/BackgroundGallery.vue'
import TextGallery from '@/components/text/TextGallery.vue'
import StickerGallery from '@/components/sticker/StickerGallery.vue'
import EffectsGallery from '@/components/effect/EffectGallery.vue'
import { useApplicationStore, ActionMenuTabs } from '@/store/application-store'

const applicationStore = useApplicationStore()

</script>

<style lang="scss">
.action-layer {
  background-color: $grey-85;
  width: 408px;
  height: 100%;

  &__galleries {
    display: flex;
    flex-direction: column;
    height: 100%;
    opacity: 100%;
    transition: opacity 400ms $animationCurve;
  }
  
  &__gallery {
    flex: 1;
  }
}
</style>
